package org.example.site_web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.example.site_web.components.images.GlobalSvg
import org.example.site_web.components.layouts.PageLayoutData
import org.example.site_web.components.sections.HeroContainer
import org.example.site_web.components.sections.OurOffer
import org.example.site_web.components.sections.WhoAreWe
import org.example.site_web.components.sections.WorkingTogether
import org.example.site_web.components.sections.WorkingTogetherResp
import org.example.site_web.components.sections.YourNeeds
import org.example.site_web.components.sections.YourProject


@InitRoute
fun initIndexPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("NewHome"))
}


@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun NewHomePage() {
    GlobalSvg()

    Column(Modifier
        .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Top
        ) {
        HeroContainer()
        YourNeeds()
        OurOffer()
        WorkingTogetherResp()
        YourProject()
        Spacer()
        WhoAreWe()
    }
}
